import React, { useContext, useEffect, useRef, useState } from 'react'
import PageTitle from '../../Components/PageTitle'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { NavLink, useLocation } from 'react-router-dom'
import { currentDateAndTime, decodeData, masterCheatCode } from '../../Constants/constants'
import Swal from 'sweetalert2'
import { ConfigContext } from '../../Context/ConfigContext'
import axios from 'axios'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import copy from 'clipboard-copy';

function useQuery () {
  return new URLSearchParams(useLocation().search)
}

const CreateMail = () => {
  const query = useQuery()
  const mail_id = query.get('id');
  const { apiURL,apiHeaderJSON, permissions } = useContext(ConfigContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encodedData = queryParams.get("abs");
  const decodedData = encodedData ? decodeData(encodedData,permissions) : [];

  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})
  const [formData, setFormData] = useState({
    mailTemplateTitle: '',
    mailSubject: '',
    mailBody: ''
  })
 
  const handleInputChange = (name, value) => {
    // console.log(name, value)
    setFormData({ ...formData, [name]: value })
    setErrors({ ...errors, [name]: '' })
  }

  const debounceTimerRef = useRef(null)
  const getBack=()=>{
    window.history.back();
}

  const handleEditorChange = (event, editor) => {
    const mailContent = editor.getData();
    console.log(mailContent);
    // Clear the previous timeout if the user is still typing
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
  
    // Set a new timeout to call the function after 1 second
    debounceTimerRef.current = setTimeout(() => {
      setFormData(prevState => ({
        ...prevState,
        mailBody: mailContent
      }));
      // Call the content change handler
      // handleContentChange(mailContent);
    }, 1000);
  
    setErrors(prevErrors => ({
      ...prevErrors,
      mailBody: ''
    }));
  };
 
  const getInfo = () => {
    const headers = apiHeaderJSON
    axios
      .get(`${apiURL}MailMaster/GetMailTemplate?mail_template_id=${mail_id}`, {
        headers
      })
      .then(response => {
        const { success, result } = response.data
        // console.log(response?.data)
        console.log("JSON",result[0]?.mail_body);
        if (success === true) {
          setFormData({
            mailTemplateTitle: result[0]?.mail_template_title,
            mailSubject: result[0]?.mail_subject,
            mailBody: result[0]?.mail_body,
          })
        } else {
        }
      })
  }
 
  useEffect(() => {
    if (mail_id) {
      getInfo();
    }
  }, []);

  const handleSubmit = e => {
    e.preventDefault()

    const errors = validateForm()
    console.error('Create Mail Error', errors)
    if (Object.keys(errors).length > 0) {
      setErrors(errors)
      return
    }
    setLoading(true)
    const data = {
      mail_template_id:mail_id || "",
      mailBody: formData?.mailBody,
      mailTemplateTitle: formData?.mailTemplateTitle,
      mailSubject: formData?.mailSubject,
      date: currentDateAndTime()
    }

    const headers = apiHeaderJSON
    // setLoading(true);
    axios
      .post(`${apiURL}MailMaster/CreateMailTemplate`, data, {
        headers
      })
      .then(response => {
        const { success } = response.data
        if (success === true) {
          setFormData({
            mailBody: '',
            mailTemplateTitle: '',
            mailSubject: ''
          });
          getBack()
          // getInfo();
          Swal.fire({
            title: `<strong>${
              response.data.success === true ? 'Success' : 'Failed'
            }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? 'success' : 'error',
            showConfirmButton: true,
            allowOutsideClick: false
          })
        } else {
          Swal.fire({
            title: `<strong>${
              response.data.success === true ? 'Success' : 'Failed'
            }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? 'success' : 'error',
            showConfirmButton: true,
            allowOutsideClick: false
          })
        }
      })
      .catch(error => {
        Swal.fire({
          title: `<strong>"Failed"</strong>`,
          text: error?.data?.message,
          icon: 'error',
          showConfirmButton: true,
          allowOutsideClick: false
        })
      })
    setLoading(false)
  }

  const validateForm = () => {
    const errors = {}
    if (!formData?.mailTemplateTitle) {
      errors.mailTemplateTitle = 'Mail template title is required!'
    }
    if (!formData?.mailSubject) {
      errors.mailSubject = 'Mail subject is required!'
    }
    if (!formData?.mailBody) {
      errors.mailBody = 'Mail Body is can not be empty!'
    }
    // console.log(formData?.mailBody);

    return errors
  }

  const handleCopyClick = (code) => {
    copy(code);
    toast.success(`Code Has Been Copied! ${code}`, { autoClose: 1500 });
  };


  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid mt-3'>
          <PageTitle title={'Create Mail'} primary={`Home`} />
         
              
              <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRight"
                aria-labelledby="offcanvasRightLabel"
                >
                <div className="offcanvas-header">
                  <h5 id="offcanvasRightLabel"> Placeholder Keys</h5>
                  <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  />
                </div>

                <div className="offcanvas-body">
                  <table class="table table-hover table-bordered border-primary table-nowrap">
                    <thead className="bg-primary text-light bg-gradient">
                      <tr>
                        <th scope="col">Names</th>
                        <th scope="col">Code</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        masterCheatCode?.map((val)=>{
                          return (
                            <tr>
                                <td>{val?.name}</td>
                                <td onClick={() => handleCopyClick(val?.code)} style={{ cursor: "pointer" }}>{val?.code}</td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </table>
                </div>
              </div>
          <div className='card'>
            <div className='card-header align-items-center d-flex'>
              <h4 className='card-title mb-0 flex-grow-1'>
                {/* {company_salary_head_id ? "Update Payroll Head" : "Create Payroll Head"} */}
                {'Create New Mail'}
              </h4>
              <div className=' d-flex align-items-center gap-2'>
              <button
                  type="button"
                  className="btn btn-primary waves-effect right waves-light btn-label"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRight"
                  aria-controls="offcanvasRight"
                >
                  <i className="ri-code-s-slash-line label-icon align-middle fs-16" />{" "}
                  Placeholder Keys
                </button>
              <NavLink className='btn btn-success btn-sm py-2' to={`/EmailTemplateList`}>
                <i className='bx bx-list-ul label-icon align-middle fs-4 ' />
              </NavLink>
              </div>
            </div>
            <div className='card-body'>
              <form onSubmit={handleSubmit}>
                <div className='row gy-4'>
                  <div className='col-md-12 mb-1'>
                    <label htmlFor='mailTemplateTitle' className='form-label'>
                      Title:
                    </label>
                    <input
                      type='text'
                      id='mailTemplateTitle'
                      name='mailTemplateTitle'
                      value={formData?.mailTemplateTitle}
                      onChange={e =>
                        handleInputChange('mailTemplateTitle', e.target.value)
                      }
                      className={`form-control ${
                        errors.mailTemplateTitle ? 'is-invalid' : ''
                      }`}
                      placeholder='Enter Template Title'
                    />

                    {errors.mailTemplateTitle && (
                      <div className='invalid-feedback'>
                        {errors.mailTemplateTitle}
                      </div>
                    )}
                  </div>
                  <div className='col-md-12 mb-3 mt-0'>
                    <label htmlFor='mailSubject' className='form-label'>
                      Subject:
                    </label>
                    <input
                      type='text'
                      id='mailSubject'
                      name='mailSubject'
                      value={formData?.mailSubject}
                      onChange={e =>
                        handleInputChange('mailSubject', e.target.value)
                      }
                      className={`form-control ${
                        errors.mailSubject ? 'is-invalid' : ''
                      }`}
                      placeholder='Enter Subject'
                    />

                    {errors.mailSubject && (
                      <div className='invalid-feedback'>
                        {errors.mailSubject}
                      </div>
                    )}
                  </div>
                </div>
                <div className='col-md-12'>
                  <CKEditor
                    editor={ClassicEditor}
                    data={formData?.mailBody}
                    name={'mailBody'}
                    onChange={handleEditorChange}
                  />
                  {errors.mailBody && (
                    <div style={{ fontSize: '12px' }} className=' text-danger'>
                      {errors.mailBody}
                    </div>
                  )}
                  <div style={{ marginTop: '30px', marginLeft: 'Auto' }}>
                    <button
                      disabled={loading}
                      type='submit'
                      className={`btn btn-primary btn-label waves-effect right waves-light float-right`}
                    >
                      <i
                        className={`ri-save-line label-icon align-middle fs-16 ms-2`}
                      />
                      {mail_id ? 'Update' : 'Save'}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateMail
